import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { IconX, IconEye, IconEyeOff } from "@tabler/icons-react";
import dataConstant from "../../constants/dataConstants";

const ResetPasswordModal = ({ open, onClose, userId, onReset }) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [errors, setErrors] = useState({});
  useEffect(() => {
    if (open) {
      setPassword("");
      setConfirmPassword("");
      setErrors({});
    }
  }, [open]);
  const validate = () => {
    const newErrors = {};

    const passwordRegex = dataConstant.passwordRegex;

    if (!password) {
      newErrors.password = "Password is required";
    } else if (!passwordRegex.test(password)) {
      newErrors.password =
        "Password must be 6-16 characters and include uppercase, lowercase, number, and special character";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm password is required";
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmit = () => {
    if (!validate()) return;

    const payload = {
      id: userId,
      password: password,
    };
    onReset(payload);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>
        Reset Password
        <IconButton onClick={onClose} sx={{ padding: 0 }}>
          <IconX />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TextField
          label="New Password"
          type={showPassword ? "text" : "password"}
          fullWidth
          required
          margin="normal"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            if (errors.password) {
              setErrors((prev) => ({ ...prev, password: undefined }));
            }
          }}
          error={!!errors.password}
          helperText={errors.password}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword((prev) => !prev)}>
                    {showPassword ? <IconEyeOff /> : <IconEye />}
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
          sx={{ mt: 0, mb: 3 }}
        />

        <TextField
          label="Confirm Password"
          type={showConfirm ? "text" : "password"}
          fullWidth
          required
          margin="normal"
          value={confirmPassword}
          onChange={(e) => {
            setConfirmPassword(e.target.value);
            if (errors.confirmPassword) {
              setErrors((prev) => ({ ...prev, confirmPassword: undefined }));
            }
          }}
          error={!!errors.confirmPassword}
          helperText={errors.confirmPassword}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowConfirm((prev) => !prev)}>
                    {showConfirm ? <IconEyeOff /> : <IconEye />}
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
          sx={{ my: 0 }}
        />

        {errors.api && (
          <div style={{ color: "red", marginTop: 8 }}>{errors.api}</div>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          size="small"
          color="primary"
          variant="outlined"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          size="small"
          color="primary"
          variant="contained"
          onClick={onSubmit}
        >
          Reset
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetPasswordModal;
